import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    marginTop: '2rem',
    padding: '0 2rem',

    [$theme.mediaQuery.large]: {
        marginTop: '4rem'
    }
}))

export const TitleContainer = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    fontWeight: 600,
    color: '#000',
    marginTop: 0,
    marginBottom: '0.8rem'
}))

export const Content = styled('div', () => ({
    marginTop: '3rem'
}))
